import { createLucideIcon } from 'lucide-react';
export const DotOutline = createLucideIcon('dot-outline', [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
